import { isValid, max } from "date-fns"

/**
 * Returns the latest (max) date from a list of dates, or null if no valid date is provided.
 *
 * @param dates - Array of dates (Date, string, or null/undefined)
 * @returns The latest valid date, or null if none
 */
export const getLatestDate = (
  dates: Array<Date | string | null | undefined>
): Date | null => {
  const parsed = dates
    .filter((d): d is Date | string => d != null && d !== undefined)
    .map((d) => (typeof d === "string" ? new Date(d) : d))
  const valid = parsed.filter((d) => isValid(d))
  if (valid.length === 0) return null
  return max(valid)
}
